export enum OutboundCallSessionParticipantType {
  userId = 'userId',
  externalPhone = 'externalPhone',
}

export type OutboundCallSessionParticipantTypeType = keyof typeof OutboundCallSessionParticipantType;
